module.exports = __webpack_public_path__ + "static/media/h4.b64f117d.svg";